'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import useUser from '@/hooks/useUser';
import { maskSecretNetworkBodies } from '@/utils/posthogNetworkMask';
const isClientSide = typeof window !== 'undefined';
if (isClientSide && process.env.NEXT_PUBLIC_POSTHOG_KEY && process.env.NODE_ENV === 'production') {
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
    api_host: '/ingest',
    ui_host: 'https://eu.posthog.com',
    defaults: '2026-01-30',
    person_profiles: 'identified_only',
    session_recording: {
      maskAllInputs: false,
      maskInputOptions: {
        password: true
      },
      maskCapturedNetworkRequestFn: maskSecretNetworkBodies
    },
    capture_exceptions: {
      capture_unhandled_errors: true,
      capture_unhandled_rejections: true,
      capture_console_errors: true
    }
  });
}
export function CSPostHogProvider(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  const {
    data: user
  } = useUser();
  let t1;
  let t2;
  if ($[0] !== user) {
    t1 = () => {
      if (user) {
        posthog.identify(user.id, {
          email: user.email
        });
      }
    };
    t2 = [user];
    $[0] = user;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== children) {
    t3 = <PostHogProvider client={posthog}>{children}</PostHogProvider>;
    $[3] = children;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}